export const API_BASE = process.env.NODE_ENV === "development"
  ? "http://localhost:5000/api"
  : "https://cung-home-server.onrender.com/api";

export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://cunghome.com").replace(/\/+$/, "");

export const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "656671430704619";

export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-669ZP82V0N";

// CRA builds preview/staging deployments with NODE_ENV=production too, so the
// hostname allow-list is enforced again at runtime in the analytics modules.
export const ANALYTICS_ENABLED =
  process.env.NODE_ENV === "production" &&
  process.env.REACT_APP_ANALYTICS_ENABLED !== "false";

export const ANALYTICS_HOSTNAMES = (process.env.REACT_APP_ANALYTICS_HOSTNAMES || "cunghome.com,www.cunghome.com")
  .split(",")
  .map((hostname) => hostname.trim().toLowerCase())
  .filter(Boolean);

export const BUSINESS_INFO = {
  name: "Cưng Home - Xưởng Sofa",
  shortName: "Cưng Home",
  alternateNames: ["Cưng Home", "Cung Home", "cunghome", "cunghome.com"],
  phone: "0984 842 841",
  phoneHref: "tel:0984842841",
  telephoneSchema: "+84984842841",
  zaloUrl: "https://zalo.me/0984842841",
  facebookUrl: "https://www.facebook.com/cunghome21",
  messengerUrl: "https://m.me/cunghome21",
  instagramUrl: "https://www.instagram.com/cunghome/",
  mapsUrl: "https://maps.app.goo.gl/Xrr9ehFUByyn7m836",
  officeLabel: "Văn phòng tư vấn",
  addressShort: "S501 Vinhomes Grand Park, Hồ Chí Minh",
  addressFull: "S501 Vinhomes Grand Park, Thành phố Hồ Chí Minh",
  workshopLabel: "Khu vực xưởng",
  workshopArea: "Long Bình, TP. Thủ Đức, Thành phố Hồ Chí Minh",
  workshopAreaShort: "Long Bình, gần Vinhomes Grand Park khoảng 1km",
  localPresence:
    "Văn phòng tư vấn tại S501 Vinhomes Grand Park; khu vực xưởng ở Long Bình, gần Vinhomes Grand Park khoảng 1km.",
  areaServed: [
    "Thành phố Hồ Chí Minh",
    "Thủ Đức",
    "Long Bình",
    "Vinhomes Grand Park",
    "Quận 9 cũ",
  ],
  knowsAbout: [
    "sofa may đo",
    "xưởng sofa TPHCM",
    "sofa phòng khách",
    "sofa chữ L",
    "sofa bed",
    "giường bọc nệm",
  ],
  address: {
    streetAddress: "S501 Vinhomes Grand Park",
    addressLocality: "Thành phố Hồ Chí Minh",
    addressRegion: "Hồ Chí Minh",
    addressCountry: "VN",
    postalCode: "712000",
  },
  coordinates: {
    latitude: 10.8459,
    longitude: 106.7793,
  },
  openingHours: [
    { day: "Monday", opens: "09:00", closes: "20:00" },
    { day: "Tuesday", opens: "09:00", closes: "20:00" },
    { day: "Wednesday", opens: "09:00", closes: "20:00" },
    { day: "Thursday", opens: "09:00", closes: "20:00" },
    { day: "Friday", opens: "09:00", closes: "20:00" },
    { day: "Saturday", opens: "09:00", closes: "21:00" },
    { day: "Sunday", opens: "09:00", closes: "21:00" },
  ],
  priceRange: "VND1000000..VND100000000",
};

export const BUSINESS_SAME_AS = [
  BUSINESS_INFO.facebookUrl,
  BUSINESS_INFO.instagramUrl,
  BUSINESS_INFO.mapsUrl,
];
